var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReemLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162,
    height: 92,
    viewBox: "0 0 162 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Reem_Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 92
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reem_Logo",
    "data-name": "Reem Logo",
    clipPath: "url(#clip-Reem_Logo)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3063",
    "data-name": "Path 3063",
    d: "M0-12H162V67.478A13.025,13.025,0,0,1,148.975,80.5H13.025A13.025,13.025,0,0,1,0,67.478Z",
    transform: "translate(0 11.497)",
    fill: "#1b2341"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819",
    transform: "translate(0.238 6.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    "data-name": "Path 3064",
    d: "M45.521,102.288H42.154v-2.9H40.92v7.275h1.234v-3.24h3.366v3.24h1.234V99.39H45.521Z",
    transform: "translate(-17.534 -42.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M57.882,99.138a3.218,3.218,0,0,0-2.595,1.143,4.406,4.406,0,0,0,0,5.224,3.463,3.463,0,0,0,5.184,0,4.429,4.429,0,0,0,0-5.224,3.212,3.212,0,0,0-2.589-1.143Zm0,6.412a1.955,1.955,0,0,1-1.68-.8,3.429,3.429,0,0,1,0-3.669,2.152,2.152,0,0,1,3.349,0,3.429,3.429,0,0,1,0,3.675,1.943,1.943,0,0,1-1.669.794Z",
    transform: "translate(-23.323 -42.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M73.1,102.451h0l-1.629-.4a1.418,1.418,0,0,1-.572-.257.572.572,0,0,1-.194-.469.857.857,0,0,1,.377-.789,1.829,1.829,0,0,1,.994-.24,1.772,1.772,0,0,1,1.069.32,1.177,1.177,0,0,1,.457.926v.286h1.212v-.314a2.183,2.183,0,0,0-.863-1.777,3.138,3.138,0,0,0-1.909-.572,2.635,2.635,0,0,0-2.08.794,2.166,2.166,0,0,0-.52,1.383,1.715,1.715,0,0,0,.572,1.343,2.738,2.738,0,0,0,1.177.571h0l1.486.366h0a2.377,2.377,0,0,1,.817.326.766.766,0,0,1,.24.251.6.6,0,0,1,.086.337.812.812,0,0,1-.126.457,1.269,1.269,0,0,1-.572.446,2.08,2.08,0,0,1-.754.149,2.44,2.44,0,0,1-1.372-.314,1.234,1.234,0,0,1-.509-1.143v-.36H69.228v.286a1.555,1.555,0,0,0,0,.16,2.286,2.286,0,0,0,.88,1.909,3.429,3.429,0,0,0,2.092.572,2.916,2.916,0,0,0,2.395-.892,2.08,2.08,0,0,0,.457-1.314,1.789,1.789,0,0,0-.634-1.423,3.315,3.315,0,0,0-1.32-.617Z",
    transform: "translate(-29.663 -42.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M85.989,99.389H82.72v7.275h1.24v-2.858h2.029a2.343,2.343,0,0,0,1.64-.572,2.377,2.377,0,0,0,0-3.246A2.286,2.286,0,0,0,85.989,99.389Zm-2.029,1.143h1.886a1.309,1.309,0,0,1,.874.269,1.177,1.177,0,0,1,0,1.6,1.309,1.309,0,0,1-.874.263H83.96Z",
    transform: "translate(-35.445 -42.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M95.73,106.665h1.234V99.39H95.73Z",
    transform: "translate(-41.019 -42.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M100.64,100.527h2.332v6.138h1.234v-6.138h2.326V99.39H100.64Z",
    transform: "translate(-43.123 -42.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    d: "M113.9,99.39l-.08.183-2.858,7.092h1.332l.806-2.08h2.629l.812,2.08h1.3l-2.858-7.275Zm.52,1.772.863,2.286h-1.755Z",
    transform: "translate(-47.545 -42.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M126.664,105.522V99.39H125.43v7.275h4.978v-1.143Z",
    transform: "translate(-53.746 -42.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M230.318,57.206V26.184h-4l-1.349-.034L214.516,48.239,203.463,26.15H202.32v8.178l10.859,20.849h2.983l9.79-20.883V62.069h4.366a3.515,3.515,0,0,0,2.492-1.143,3.766,3.766,0,0,0,1.143-2.749v-.972Z",
    transform: "translate(-86.692 -11.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 4.309,
    height: 10.63,
    transform: "translate(23.363 39.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M76.063,80.5H70.354L62.17,69.88h5.7Z",
    transform: "translate(-26.639 -29.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M93,26.38V38.193h3.943V30.346h12.179V26.38ZM96.943,58V47.526H93V61.945h16.122V58Z",
    transform: "translate(-39.85 -11.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M130.8,26.38V38.193h3.943V30.346h12.173V26.38ZM134.743,58V47.526H130.8V61.945h16.117V58Z",
    transform: "translate(-56.047 -11.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M112.3,26.037h-4.824V35.5a.251.251,0,0,0,0,.029V36.1a4.073,4.073,0,0,1-2.938,4.229,4.572,4.572,0,0,1-1.5.246,1.864,1.864,0,0,1-.309,0H58.726a10.727,10.727,0,0,0,.514-3.292,10.5,10.5,0,0,0-3.629-8A12.442,12.442,0,0,0,46.884,26H34.454V40.588H25.83v4.063h0v.171h0a3.429,3.429,0,0,0,1.143,2.417,3.652,3.652,0,0,0,2.663,1.092h.92V44.823h3.9v3.7h14.9l.423-.229a12.15,12.15,0,0,0,6.287-3.492h46.7c3.355,0,5.858-.989,7.43-2.772a6.983,6.983,0,0,0,1.006-1.423v-.04a.286.286,0,0,1,.086-.149c0-.034.057-.051.074-.1h0a9.178,9.178,0,0,0,.892-4.109ZM52.559,42.285a8.373,8.373,0,0,1-5.675,2.052H38.74V30.306h8.144a8.344,8.344,0,0,1,5.675,2.052A6.338,6.338,0,0,1,54.926,37.3a6.458,6.458,0,0,1-2.366,4.989Z",
    transform: "translate(-11.068 -11.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 0.92,
    height: 0.96,
    transform: "translate(100.934 55.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 0.92,
    height: 0.96,
    transform: "translate(110.238 56.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 0.92,
    height: 0.972,
    transform: "translate(109.478 55.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 0.92,
    height: 0.96,
    transform: "translate(108.718 56.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 0.932,
    height: 0.96,
    transform: "translate(121.634 56.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 0.92,
    height: 0.96,
    transform: "translate(120.114 56.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M209.455,102.081a1.977,1.977,0,0,0-1.606-.743,2.049,2.049,0,0,0-2.075,2.337,2.446,2.446,0,0,0,.509,1.543h-5.715a.966.966,0,0,1-.686-.314,1.4,1.4,0,0,1-.4-.954v-2.475h-.857q.034,2.715.034,3.069a.817.817,0,0,1-.88.846,1.566,1.566,0,0,1-1.069-.337,1.337,1.337,0,0,1-.452-1.04c0-.983,0-1.715,0-2.177H195.4c0,1.543.04,2.446.04,2.709a.783.783,0,0,1-.846.846c-.96,0-1.457-.457-1.469-1.377v-2.177h-.857v3.383H189.3a.949.949,0,0,1-.68-.337,1.509,1.509,0,0,1-.389-1.046v-2.36h-.857a24.916,24.916,0,0,1,0,2.858.76.76,0,0,1-.377.674,1.143,1.143,0,0,1-.646.189h-5.2a.954.954,0,0,1-.68-.314,1.355,1.355,0,0,1-.4-.954v-2.475h-.863c.029,1.812.04,2.858.04,3.069a.817.817,0,0,1-.92.869,1.577,1.577,0,0,1-1.069-.337,1.314,1.314,0,0,1-.446-1.04c0-.983,0-1.715,0-2.177h-.863c0,1.543.04,2.446.04,2.709a.783.783,0,0,1-.846.846c-.954,0-1.457-.457-1.469-1.377v-2.177h-.857v3.383h-3.143a6.573,6.573,0,0,1-1.057-.063,2.989,2.989,0,0,0,1.04-1.206,2.743,2.743,0,0,0,.3-1.206,2.069,2.069,0,0,0-.646-1.617,2.286,2.286,0,0,0-2.978,0,2.1,2.1,0,0,0-.634,1.617,2.743,2.743,0,0,0,.3,1.206,2.96,2.96,0,0,0,1.046,1.206,6.716,6.716,0,0,1-1.063.063H163.98a.857.857,0,0,1-.783-.783,5.835,5.835,0,0,0-.411-1.84,2.012,2.012,0,0,0-1.966-1.246q-2.377,0-2.377,3.132h2.315v.709a2.64,2.64,0,0,1-.72,1.88,2.286,2.286,0,0,1-1.715.783,2.337,2.337,0,0,1-1.715-.772,2.6,2.6,0,0,1-.72-1.863v-1.532h-.857c0,.709.04,1.206.051,1.52a3.475,3.475,0,0,0,.966,2.486,3.149,3.149,0,0,0,4.658,0,3.463,3.463,0,0,0,.966-2.475l-.034-1.532h-2.229a1.526,1.526,0,0,1,.411-1.069,1.4,1.4,0,0,1,2.286.349,4.824,4.824,0,0,1,.326,1.577,1.594,1.594,0,0,0,.5,1.057,1.406,1.406,0,0,0,.96.411h2.126a4.532,4.532,0,0,0,1.88-.423,4.572,4.572,0,0,0,1.875.423h3.955v-.572a1.389,1.389,0,0,0,.526.509,2.12,2.12,0,0,0,.977.189,1.463,1.463,0,0,0,1.56-.983,1.8,1.8,0,0,0,.686.794,1.983,1.983,0,0,0,.989.217,1.583,1.583,0,0,0,1.583-1.109,1.3,1.3,0,0,0,1.229.932h5.366a1.714,1.714,0,0,0,1.555-1.006,1.589,1.589,0,0,0,.309.532,1.189,1.189,0,0,0,.943.474h3.7v-.572a1.377,1.377,0,0,0,.52.509,2.132,2.132,0,0,0,.983.189,1.457,1.457,0,0,0,1.555-.983,1.835,1.835,0,0,0,.686.794,1.989,1.989,0,0,0,.994.217,1.572,1.572,0,0,0,1.577-1.109,1.3,1.3,0,0,0,1.234.932h7.315c1.292,0,2.052-.886,2.052-2.337A2.435,2.435,0,0,0,209.455,102.081Zm-41.617,2.652c-.189,0-.429-.177-.709-.537a2.149,2.149,0,0,1-.537-1.452,1.715,1.715,0,0,1,.309-1.057,1.1,1.1,0,0,1,.92-.474,1.143,1.143,0,0,1,.937.474,1.754,1.754,0,0,1,.309,1.057,2.286,2.286,0,0,1-.509,1.452C168.272,104.556,168.038,104.733,167.838,104.733Zm40.96.16a1.017,1.017,0,0,1-.834.4,1.109,1.109,0,0,1-.857-.4,1.794,1.794,0,0,1-.4-1.229,1.9,1.9,0,0,1,.36-1.234,1.046,1.046,0,0,1,.834-.394,1.143,1.143,0,0,1,.857.394,1.852,1.852,0,0,1,.4,1.234A1.9,1.9,0,0,1,208.8,104.893Z",
    transform: "translate(-66.429 -43.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M183.058,42.044V43.5a24.428,24.428,0,0,1-.189,2.64c-.074.572-.166,1.143-.286,1.663a17.745,17.745,0,0,1-3.766,7.864h0c-.16.177-.3.349-.457.526A17.334,17.334,0,0,1,166.045,62c-.44-.732-1.092-2.017-1.955-3.789a13.754,13.754,0,0,0,10.35-4.178A14.288,14.288,0,0,0,178.5,43.678l-.04-10.081V26.39h4.5l.12,14.711Z",
    transform: "translate(-70.311 -11.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 2.789,
    height: 2.789,
    transform: "translate(88.906 37.919) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 2.789,
    height: 2.789,
    transform: "translate(95.094 37.915) rotate(-45)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReemLogo1);
export default __webpack_public_path__ + "static/media/Reem-Logo-1.fbbb4dee345ad8edfa18d0ddf8e7943e.svg";
export { ForwardRef as ReactComponent };